import { TAccountRightsFeatureList } from '@app/services/account-rights-service/response-interfaces/account-rights';

export const FEATURE_PRODUCT_VALUE_LABELING: TAccountRightsFeatureList =
  'ProductValueLabeling';
